import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { LDWDocument } from '../../../shared/models/LDWDocument';
import { DocumentHelper } from '../../../shared/helpers/document-helper';
import { MatDialog } from '@angular/material/dialog';
import { LdwRouterService } from '../../../route/ldw-router.service';
import { WebdokuService } from '../../../web-doku/webdoku.service';
import { DocumentService } from '../../../shared/services/document.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'ldw-detail-document-view',
    templateUrl: './detail-document-view.component.html',
    styleUrls: ['./detail-document-view.component.css'],
    standalone: false
})
export class DetailDocumentViewComponent {
  private dialog = inject(MatDialog);
  private routerService = inject(LdwRouterService);
  private webDokuService = inject(WebdokuService);
  private documentService = inject(DocumentService);
  private translate = inject(TranslateService);

  private _documentId = '';
  document: LDWDocument | undefined = undefined;
  documentHelper: DocumentHelper;
  @Output() visibleChanged: EventEmitter<boolean> = new EventEmitter();
  @Input() search = '';

  constructor() {
    const dialog = this.dialog;
    const routerService = this.routerService;
    const translate = this.translate;

    this.documentHelper = new DocumentHelper(dialog, routerService, translate);
  }

  @Input()
  get documentId(): string {
    console.log('get documentId ' + this._documentId);
    return this._documentId;
  }
  set documentId(value: string) {
    console.log('set documentId ' + value);
    if (this._documentId == value) {
      return;
    }
    this._documentId = value;
    this.loadDocument(this._documentId);
  }

  public clear() {
    console.log('clear');
    this.document = undefined;
    this.visibleChanged.emit(false);
    this._documentId = '';
  }

  public loadDocument(docId: string) {
    console.log('load ' + docId);
    this.documentService.getDocument(docId).subscribe(
      (value) => this.loaded(value),
      () => this.error(docId)
    );
  }

  loaded(value: LDWDocument) {
    console.log('loaded');
    this.document = value;
    this.visibleChanged.emit(true);
  }

  error(docId: string) {
    this.documentHelper.documentNotFound(docId);
    this.visibleChanged.emit(false);
  }

  closeDetail() {
    this.clear();
  }
}
